import {AfterViewInit, Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import e from "express";

@Component({
  selector: 'app-docu-sign-dialog',
  templateUrl: './docu-sign-dialog.component.html',
  styleUrl: './docu-sign-dialog.component.scss'
})
export class DocuSignDialogComponent implements OnInit, AfterViewInit{
  urlSafe: SafeResourceUrl;

  url: string = 'https://www.youtube.com/embed/dQw4w9WgXcQ';
  constructor(public dialogRef: MatDialogRef<DocuSignDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: string, public sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    // this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.data);

  }
  private loadDocuSign(signUrl: string) {
    //@ts-ignore
    window.DocuSign.loadDocuSign('3079f871-a089-40a8-b60b-8f07836b52ea').then((docusign: any) => {
        const signing = docusign.signing({
          url:signUrl,
          displayFormat: 'focused',
          style: {

            /** High-level variables that mirror our existing branding APIs. Reusing the branding name here for familiarity. */
            branding: {
              primaryButton: {
                /** Background color of primary button */
                backgroundColor: '#333',
                /** Text color of primary button */
                color: '#fff',
              },

            },

            /** High-level components we allow specific overrides for */
            signingNavigationButton: {
              finishText: 'Fermer',
              /** 'bottom-left'|'bottom-center'|'bottom-right',  default: bottom-right */
              position: 'bottom-left'
            }
          }
        });

        /* Event handlers */
        signing.on('ready', (event: any) => {
          console.log('UI is rendered');
        });

        signing.mount('#agreement');
      })
      .catch((ex: any) => {
        console.log("ex", ex)
      });

    window.addEventListener('message', (e) => {
      if (e != null && e.data != null && e.data.eventType != null && e.data.eventType == "sessionEnd") {
        this.dialogRef.close('sessionEnd');
      }

      if (e != null && e.data != null && e.data.eventType != null && e.data.eventType == "fullScreenActivityStarted") {
        this.dialogRef.close('fullScreenActivityStarted');
      }
    })
  }

  ngAfterViewInit(): void {
    this.loadDocuSign(this.data)
  }

}
